"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var APIService_1 = __importDefault(require("../APIService"));
var EventContext_1 = __importDefault(require("./EventContext"));
var EventErrorReport_1 = __importDefault(require("./EventErrorReport"));
var EventFlow_1 = __importDefault(require("./EventFlow"));
var EventStruct_1 = __importDefault(require("./EventStruct"));
/* eslint-disable no-use-before-define */
var EventCollector = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onTokenExpired, onTokenExpired = _c === void 0 ? function () { } : _c, _d = _b.APIServiceCtor, APIServiceCtor = _d === void 0 ? APIService_1.default : _d, _e = _b.EventFlowCtor, EventFlowCtor = _e === void 0 ? EventFlow_1.default : _e, baseUrlResolver = _b.baseUrlResolver, _f = _b.apiVersionResolver, apiVersionResolver = _f === void 0 ? function () { return 'v3'; } : _f, _g = _b.headersResolver, headersResolver = _g === void 0 ? function (authSetting) { return ({
        Authorization: (authSetting && authSetting.getAccessToken()) || undefined,
    }); } : _g, ideal = _b.ideal, retryTimes = _b.retryTimes, retryIdeal = _b.retryIdeal, enableBatching = _b.enableBatching;
    var eventContext = EventContext_1.default();
    var errorReport = EventErrorReport_1.default();
    var apiService = APIServiceCtor({
        baseUrlResolver: baseUrlResolver,
        apiVersionResolver: apiVersionResolver,
        headersResolver: function () {
            var authSetting = (eventContext.getEventContext() || {}).authSetting;
            return headersResolver(authSetting);
        },
    });
    var eventStruct = EventStruct_1.default({
        getEventContext: eventContext.getEventContext,
    });
    var eventFlow = EventFlowCtor({
        apiCallFunc: apiService.postEvents,
        errorReport: errorReport,
        onTokenExpired: onTokenExpired,
        ideal: ideal,
        retryTimes: retryTimes,
        retryIdeal: retryIdeal,
        enableBatching: enableBatching,
    });
    function completeEventObject(eventObject) {
        var newEventObject = eventStruct.createEventObject(eventObject);
        var clientDetails = newEventObject.data && newEventObject.data.clientDetails;
        var newClientDetails = eventStruct.createEventClientDetails(clientDetails);
        newEventObject.data = __assign(__assign({}, newEventObject.data), { clientDetails: newClientDetails });
        return newEventObject;
    }
    function pushEvent(eventObject, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.autoComplete, autoComplete = _c === void 0 ? true : _c;
        var newEventObject = eventObject;
        if (autoComplete) {
            newEventObject = completeEventObject(eventObject);
        }
        console.info('events infomation:', newEventObject);
        eventFlow.addEvent(newEventObject);
        eventFlow.flushEvents();
    }
    var result = {
        getEventsQueue: eventFlow.getEventsQueue,
        getErrorReport: errorReport.get,
        setEventContext: eventContext.setEventContext,
        getEventContext: eventContext.getEventContext,
        createEventObject: eventStruct.createEventObject,
        createEventClientDetails: eventStruct.createEventClientDetails,
        createEventIntegratorContext: eventStruct.createEventIntegratorContext,
        pushEvent: pushEvent,
    };
    return result;
};
exports.default = EventCollector;
//# sourceMappingURL=index.js.map